import React, { useRef, useState, useEffect } from 'react';
import Header from '../Header/Header';
import SectionWrapper from '../common/SectionWrapper/SectionWrapper';
import TicketList from '../../TicketList/TicketList';
import CharityBlock from '../CharityBlock/CharityBlock';
import TimelineBlock from '../TimelineBlock/TimelineBlock';
import Footer from '../Footer/Footer';
import Hero from '../Hero/Hero';
import DreamDraw from '../DreamDraw/DreamDraw';
import MobileCTAButtonBottom from '../../mobile-cta-button-bottom';
import TicketSelector from '../../TicketSelector/TicketSelector';
import PageLoader from '../../../components/PageLoader/PageLoader';
import useIsLoggedIn from '../../../hooks/useIsLoggedIn';
import { getUser } from '../../../services/users';
import './style.css';

const Main = (props) => {
  const {
    prizeId,
    raffles,
    raffle,
    activeRaffles,
    subscriptionModels,
    data,
    onCTAClick,
    onTwo4One,
    widgets,
    content,
    bonusDraw,
  } = props;
  const ticketSelectorRef = useRef(null);
  const [isDouble, setIsDouble] = useState(false);
  const isLoggedIn = useIsLoggedIn();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (props.raffles && props.raffles.length > 1) {
      setIsDouble(true);
    }
  }, [props.raffles]);

  useEffect(() => {
    if (!isLoggedIn) {
      setUser(null);
      return;
    }

    let cancelled = false;

    getUser().then((fetchedUser) => {
      if (!cancelled) {
        setUser(fetchedUser);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [isLoggedIn]);

  if (!content || !content.dreamHome) {
    return (
      <div className="app">
        <Header raffle={raffle} user={user} />
        <PageLoader loading />
        <Footer insideComponent={true} widget={widgets.footerWidget} />
      </div>
    );
  }
  return (
    <>
      {prizeId ? (
        <div className="app">
          <Header raffle={raffle} user={user} />
          <main>
            <Hero
              onCTAClick={onCTAClick}
              onTwo4One={onTwo4One}
              content={content}
              raffles={raffles}
            />
            <MobileCTAButtonBottom
              variant="variant-2"
              currentRaffle={raffle}
              withCountdown
              raffles={activeRaffles.length > 0 ? activeRaffles : raffles}
            />
            {/* <SectionWrapper bg="bg-2">
              {isDouble && ( 
                  <div className="update__2-4-1">
                    <button className="update-buttons__2-4-1-btn" onClick={onTwo4One} >
                      
                      <p>View 2-4-1 Home Offer</p>
                    </button> 
                  </div>
                ) 
                }
            </SectionWrapper> */}
            <SectionWrapper bg="bg-2">
              <TicketSelector
                reference={ticketSelectorRef}
                title={data.ticketSelector.title}
                subtitle={content.dreamHome.timeLine.description}
                prizeId={prizeId}
                subscriptionModels={subscriptionModels}
                raffles={activeRaffles.length > 0 ? activeRaffles : raffles}
                currentRaffle={raffle}
                theme="light"
                bonusDraw={bonusDraw}
                user={user}
              />
            </SectionWrapper>
            <SectionWrapper bg="bg-1">
              <CharityBlock />
            </SectionWrapper>
            <SectionWrapper bg="bg-2">
              <TimelineBlock
                onCTAClick={onCTAClick}
                content={content.dreamHome.timeLine}
              />
            </SectionWrapper>
            <SectionWrapper bg="bg-1">
              <div className="footer-margin"></div>
            </SectionWrapper>
            <Footer
              insideComponent={true}
              widget={widgets.footerWidget}
              bonusDraw={bonusDraw}
            />
          </main>
        </div>
      ) : (
        <main className="no-prize">
          <h1>No prize</h1>
        </main>
      )}
    </>
  );
};

export default Main;
